import React from "react";
import "./Editor.css";
import OperationForm from "../OperationForm/OperationForm";

function Editor({ divisionId }) {
  return (
    <div
      className=""
      style={{ maxWidth: "25vw", padding: "5px", minWidth: "25vw" }}
    >
      <OperationForm divisionId={divisionId} />
    </div>
  );
}

export default Editor;
